import { useState } from 'react';

import { Button } from '../components/ui/button';
import { useLab } from '../lib/service';
import { ChevronDown } from 'lucide-react';
import { label } from '../shared';

/** Viewer scores captured against a specific accepted master. */
export function ReviewForm({
  episodeId,
  onError,
}: {
  episodeId: string;
  onError: (e: unknown) => void;
}) {
  const lab = useLab();
  const [open, setOpen] = useState(false),
    [saved, setSaved] = useState(false),
    [scores, setScores] = useState({ identity: 3, continuity: 3, dialogue: 3, story: 3 }),
    [wantsNext, setWantsNext] = useState(true),
    [notes, setNotes] = useState('');
  return (
    <div className="viewer-review">
      <Button variant="ghost" onClick={() => setOpen(!open)}>
        {saved ? 'Feedback saved' : 'Leave viewer feedback'}
        <ChevronDown size={14} />
      </Button>
      {open && (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            void lab
              .review({ episodeId, scores, wantsNext, notes })
              .then(() => {
                setSaved(true);
                setOpen(false);
              })
              .catch(onError);
          }}
        >
          {Object.entries(scores).map(([k, value]) => (
            <label key={k}>
              {label(k)}
              <select
                value={value}
                onChange={(e) => setScores({ ...scores, [k]: Number(e.target.value) })}
              >
                {[1, 2, 3, 4, 5].map((n) => (
                  <option key={n}>{n}</option>
                ))}
              </select>
            </label>
          ))}
          <label className="checkbox">
            <input
              type="checkbox"
              checked={wantsNext}
              onChange={(e) => setWantsNext(e.target.checked)}
            />
            I want to watch Episode 2
          </label>
          <textarea
            aria-label="Viewer feedback notes"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="What stayed with you?"
            maxLength={2000}
          />
          <Button type="submit">Save feedback</Button>
        </form>
      )}
    </div>
  );
}
